import React, { useEffect, useState } from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import SelectUser from '../General/SelectUser';
import AddItemForm from '../Forms/AddItemForm';
import SearchFormPanel from './SearchFormPanel';
import GiftIdeasPanel from './GiftIdeasPanel';
import LoadingOverlay from '../General/LoadingOverlay';

const AddItem = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [response, giftlistActions] = useGlobal(
        state => state.response,
        actions => actions.giftlistActions
    );

    useEffect(() => {
        if(panel.name !== "additem") {
            return;
        }
        console.log('PANEL STATE CHANGE', panel);
        if(panel.state && panel.state.selectedUser) {
            setSelectedUser(panel.state.selectedUser);
        }
    }, [panel]);

    const closePanel = () => {
        uiActions.closeSidePanel();
    }

    const selectedUserChanged = (selectedUserData) => {
        console.log('NEW SELECTED USER', selectedUserData);
        setSelectedUser(selectedUserData);
    }

    const tabClick = (tab, e) => {
        e.preventDefault();
        uiActions.updateSidePanelState({ activeTab: tab });
    }

    const handleAddItemFormSubmit = (formData) => {
        formData.userID = selectedUser.userID;
        delete formData.source;
        console.log('ADDING ITEM....', formData);
        setIsLoading(true);
        giftlistActions.addItem(formData);
    }

    const handleAddItemFromSearch = (itemData) => {
        itemData.userID = selectedUser.userID;
        console.log('ADDING SEARCH ITEM....', itemData);
        setIsLoading(true);
        giftlistActions.addItem(itemData);
    }
    

    const renderTab = () => {
        switch (panel.state.activeTab) {
            case "giftidea":
                return <GiftIdeasPanel user={selectedUser}></GiftIdeasPanel>
            case "search":
                return <SearchFormPanel addItemHandler={handleAddItemFromSearch}></SearchFormPanel>
            default:
                return <AddItemForm submitForm={handleAddItemFormSubmit} selectedUser={selectedUser}></AddItemForm>
        }
    }

    useEffect(() => {
        if(!response || (response.type !== "parseurl" && response.type !== "additem")) {
            return;
        }
        console.log('GOT A RESPONSE - ADD ITEM!', response);
        setIsLoading(false);
        if(response.type === "additem") {
            uiActions.closeSidePanel();
        }
        uiActions.clearResponse();
    }, [response, uiActions]);

    return (
        <Panel id="additempanel" open={props.open && panel.name === "additem"}>
            {props.name === "additem" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white mb-0" kt-hidden-height="77">
                    <h3 className="mb-0">Add Item</h3>
                    <button className="kt-offcanvas-panel__close" id="kt_quick_panel_close_btn" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                <div className="kt-offcanvas-panel__nav mb-0">
                    <SelectUser onChange={selectedUserChanged} selectedUser={selectedUser}></SelectUser>
                </div>
                <div className="kt-offcanvas-panel__body">
                    <ul className="nav nav-tabs nav-tabs-line" role="tablist">
                        <li className="nav-item hover-cursor">
                            <a href="#!" className={`nav-link ${panel.state.activeTab === "website" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("website", e)} role="tab">
                            <i className="la la-link"></i>Website</a>
                        </li>
                        <li className="nav-item hover-cursor">
                            <a href="#!" className={`nav-link ${panel.state.activeTab === "giftidea" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("giftidea", e)} role="tab">
                                <i className="la la-heart-o"></i>Gift Idea</a>
                        </li>
                        <li className="nav-item hover-cursor">
                            <a href="#!" className={`nav-link ${panel.state.activeTab === "search" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("search", e)} role="tab">
                            <i className="la la-search"></i>Search</a>
                        </li>
                        
                    </ul>
                    <div className="tab-content content-scroll">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" id="kt_quick_panel_tab_notifications" role="tabpanel" >
                            <div>
                                {isLoading ? <LoadingOverlay></LoadingOverlay> :<></> } 
                                {renderTab()}
                            </div>
                        </div>
                    </div>
                </div>
                </> : <></>}
        </Panel>

    );
}

export default AddItem;